import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Page from "../components/Page";
import withNav from "../utils/hoc/withNav";
import OrderService from "../services/OrderService";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../lib/anayltics";
import { IonPage } from "@ionic/react";

const Content = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const Tick = styled.svg`
	width: 175px;
	height: 204px;
	align-self: center;
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 24px;
	text-align: center;
	color: #ffcc00;
	margin-top: 35px;
    text-transform: uppercase;
`;
const SubTitle = styled.div`
	font-style: normal;
	font-weight: normal;
	font-weight: 700;
	font-size: 14px;
	text-align: center;
	letter-spacing: 0.02em;
	color: #f2f2f2;
	margin-top: 16px;
    width: 75%;
    line-height: 20px;
`;

const BigSpace = styled.div`
	margin: 2rem 0 0 0;
`;

const Link = styled.div`
	font-style: normal;
	font-weight: normal;
	font-weight: 700;
	font-size: 14px;
	text-align: center;
	letter-spacing: 0.02em;
	color: #f2f2f2;
	margin-top: 16px;
	text-decoration: underline;
`;

const TimerIcon = styled.img`
	width: 170px;
	height: 170px;
	margin-top: 2rem;
	color: #ffcc00;
`;

const OrderStatus: React.FC = (props: any) => {
	const { navigate } = props;

	// function onPageLoad() {
	// 	Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Order Status");
	// }

	// useEffect(() => {
	// 	onPageLoad();
	// }, []);

	function renderPage() {
		return (
			<>
				<TimerIcon src={"https://res.cloudinary.com/xook/image/upload/v1739186987/app.xook.ai/Wait_icon_tz1fo4.png"} />
				<Title>Sign in to Continue</Title>
				<BigSpace />
				<SubTitle>The link you are trying to access is expired. Kindly sign in to continue. </SubTitle>
				<Link
					onClick={() => {
						navigate.push(`/login`);
					}}>
					Sign in
				</Link>
			</>
		);
	}

	return (
		<IonPage>
			<Page>
				<Content>{renderPage()}</Content>
			</Page>
		</IonPage>
	);
};

export default withNav(OrderStatus);
